export function loadExternalScript(
  url: string,
  scriptTagId: string,
  tagAttributes?: Record<string, string>,
): Promise<void> {
  const script = document.getElementById(scriptTagId);

  if (script) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = url;
    script.id = scriptTagId;
    script.async = true;

    if (tagAttributes) {
      Object.entries(tagAttributes).forEach(([key, value]) => {
        script.setAttribute(key, value);
      });
    }

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`));

    document.head.appendChild(script);
  });
}

export const loadPaddleBillingScript = () => {
  const envUrl = import.meta.env.VITE_SCRIPT_URL_PADDLE_BILLING;
  const bypassUrl = 'https://cdn.paddle.com/paddle/v2/paddle.js';

  return loadExternalScript(envUrl || bypassUrl, 'paddle-script');
};

export const loadGooglePayScript = () => {
  const envUrl = import.meta.env.VITE_SCRIPT_URL_GOOGLE_PAY;
  const bypassUrl = 'https://pay.google.com/gp/p/js/pay.js';

  return loadExternalScript(envUrl || bypassUrl, 'google-pay-script');
};

export const loadApplePayScript = () => {
  const envUrl = import.meta.env.VITE_SCRIPT_URL_APPLE_PAY;
  const bypassUrl =
    'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

  return loadExternalScript(envUrl || bypassUrl, 'apple-pay-script', {
    crossorigin: 'anonymous',
  });
};

export const loadAppleAuthScript = () => {
  const envUrl = import.meta.env.VITE_SCRIPT_URL_APPLE_AUTH;
  const bypassUrl =
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

  return loadExternalScript(envUrl || bypassUrl, 'apple-auth-script');
};
